import { createReducer, createAction, createSelector } from 'redux-starter-kit';

// State
export interface IntlState {
  language: string;
}

export const initialState: IntlState = {
  language: 'en',
};

// Actions
const SET_LANGUAGE = 'intl/SET_LANGUAGE';

const setLanguage = createAction(SET_LANGUAGE);

export const intlActions = {
  setLanguage,
};

// Selectors
export const intlSelectors = {
  language: createSelector(['intl.language']),
};

// Reducers
export default createReducer(initialState, {
  [SET_LANGUAGE]: (state, action) => {
    state.language = action.payload;
  },
});
